import { Component } from '@angular/core';
import { LayoutBaseRenderComponent } from 'render/render-shared/layout-base-render/layout-base-render.component';

import { LayoutFullWidthSettings } from './models/layout-full-width.models';


@Component({
  selector: 'layout-full-width-render',
  templateUrl: './layout-full-width-render.component.html',
  styleUrls: ['./layout-full-width-render.component.scss']
})
export class LayoutFullWidthRenderComponent extends LayoutBaseRenderComponent<LayoutFullWidthSettings> { }
